export const IconArrow = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.14645 1.89645C4.34171 1.70118 4.65829 1.70118 4.85355 1.89645L8.60355 5.64645C8.79882 5.84171 8.79882 6.15829 8.60355 6.35355L4.85355 10.1036C4.65829 10.2988 4.34171 10.2988 4.14645 10.1036C3.95118 9.90829 3.95118 9.59171 4.14645 9.39645L7.54289 6L4.14645 2.60355C3.95118 2.40829 3.95118 2.09171 4.14645 1.89645Z"
            />
        </svg>
    );
};
